import React, { useEffect, useState } from 'react'
import { addDlrCommentApi, getDlrCommentsApi, getDailyLabourReportByIdApi, approveOrRejectDailyLabourReportApi } from '../../../utils/ApiEndpointFunctions'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useUserContext } from '../../../context/userContext';
import ConfirmationModal from '../../../components/modal/ConfirmationModal';
import toast from 'react-hot-toast';
import moment from 'moment';
import StatusModal from '../../../components/modal/StatusModal';
import { getDbS3Url, getLocalizationStatus } from '../../../utils/HelperFuncitons';
import './ViewDLR.css';
import ActivityHistory from '../../../components/common/ActivityHistory';


function ViewDLR() {
  const params = useParams();
  const { userDetails,langPreference } = useUserContext();
  const { id } = params;
  const [details, setDetails] = useState();
  const navigate = useNavigate();
  const confirmModalId = "conFirmModalID"
  const statusModalId = "statusModal"
  const [updatedStatus,setUpdatedStatus] = useState(null)
  const [confirmationMsg, setConfirmationMsg] = useState('')
  const [navigationRoute, setNavigationRoute] = useState("")
  const [download,setDownload] = useState(false)
  const [comments, setComments] = useState([])
  const [comment, setComment] = useState("")
  const [savingComment, setSavingComment] = useState(false)
  const location = useLocation();
  const company = details?.site?.[0]?.companyData?.[0] || userDetails?.siteId?.companyId;
  const companyAsset = (key) => key ? `${getDbS3Url(company?.s3Url)}${encodeURIComponent(key)}` : "";
  const canComment = userDetails?.roleId?.permission?.includes("dlrComment");
  const displaySections = details?.sections?.length
    ? details.sections
    : details?.items?.length
      ? [{ _id: "legacy", workItem: "", location: "", remarks: details?.remarks || "", items: details.items }]
      : [];
  

  const getDailyLabourReportById = async (id) => {
    try{
      const res = await getDailyLabourReportByIdApi(id)
      
      if (res.status === 200) {
        const podata = res.data?.data
        setDetails(podata);
      }
    }catch(err){
      console.log(err)
      if (err.response && err.response.data) {
        toast.error(err.response.data.message)
      } else {
        toast.error("Something went wrong")
      }
    }
  }

  const getComments = async () => {
    try {
      const response = await getDlrCommentsApi(id)
      setComments(response?.data?.data || [])
    } catch (error) {
      toast.error(error?.response?.data?.message || "Unable to load comments")
    }
  }

  const submitComment = async (event) => {
    event.preventDefault()
    if (!comment.trim()) return
    setSavingComment(true)
    try {
      const response = await addDlrCommentApi({ id, comment: comment.trim() })
      setComments((current) => [...current, response.data.data])
      setComment("")
      toast.success(response.data.message || "Comment added")
    } catch (error) {
      toast.error(error?.response?.data?.message || "Unable to add comment")
    } finally {
      setSavingComment(false)
    }
  }
  

  const handleApproval = async () => {
    try {
      const res = await approveOrRejectDailyLabourReportApi({ id: id,status:updatedStatus })
      if (res.status === 200) {
        // toast.success(res.data?.message)
        document.getElementById(confirmModalId).click()
        setConfirmationMsg(res?.data?.message || `DLR ${details?.dprNumber || ""} is successfully ${updatedStatus}.`)
        document.getElementById("statusModalBtn").click()
        setNavigationRoute('')
        getDailyLabourReportById(id)
      }
    } catch (error) {
      console.log(error)
      toast.error("something went wrong");
    }
  }


  const handleCloseStatusModal = () => {
    if(navigationRoute){
      navigate(navigationRoute)
    }
  }

  useEffect(() => {
    if (id) {
      getDailyLabourReportById(id)
      getComments()
    }
  }, [])

  const getDownloadDpr = async () => {
    if (download || !id) return
    let downloadUrl
    try {
      setDownload(true)
      const response = await getDailyLabourReportByIdApi(id,true)
      downloadUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', details?.dlrNumber ? `${details.dlrNumber}.pdf` :'DLR.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("Successfully downloaded");
    } catch (error) {
      toast.error("Failed to download");
    } finally {
      if (downloadUrl) window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000)
      setDownload(false)
    }
  }




  return (
    <>
      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="back"><span onClick={() => navigate(location?.state?.path ? location?.state?.path : -1, { state: { ...location?.state } })} className="back cursor-pointer" ><i className="bi bi-chevron-left"></i> {langPreference.back || "Back"}</span></div>
            <div className="main-content">
              <div className="dlr-workspace">
                <div className="card dlr-document my-3 p-0 overflow-hidden">
                  {company?.letterheadHeader && <img src={companyAsset(company.letterheadHeader)} alt="Company letterhead header" className="d-block w-100" style={{ height: "auto" }} />}
                  <div className="p-5">
                  <div>
                    <div className="row row-cols-2 mb-2">
                      <div className="fw-bold">{langPreference.company || "Company"}</div>
                      <div>{company?.name || ""}</div>
                    </div>
                    <div className="row row-cols-2">
                      <div className="fw-bold">{langPreference.site || "Site"}</div>
                      <div>{details?.site?.[0]?.name}</div>
                    </div>
                    <hr />
                  </div>
                  <div className="row g-3 mt-1">
                    <div className="col-12 col-md-4">
                      <div className="fw-bold">{langPreference.dlr_number || "DLR Number"}</div>
                      <div>{details?.dlrNumber}</div>
                    </div>
                    <div className="col-12 col-md-4">
                      <div className="fw-bold">{langPreference.date || "Date"}</div>
                      <div>{moment(details?.createDate).format("DD/MM/YYYY")}</div>
                    </div>
                    <div className="col-12 col-md-4">
                      <div className="fw-bold">{langPreference.status || "Status"}</div>
                      <div className='text-capitalize'>{getLocalizationStatus(langPreference,details?.status)}</div>
                    </div>
                  </div>
                  
                  <hr/>
                  <h3 className="dlr-items-heading">{langPreference.items || "Items"} ({details?.items?.length || 0})</h3>

                  <div className="dlr-sections">
                    {displaySections.map((section, sectionIndex) => {
                      const sectionItems = section?.items || [];
                      const totalTechnical = section?.totalTechnical ?? sectionItems.reduce((total, item) => total + Number(item?.noOfTechnical || 0), 0);
                      const totalNonTechnical = section?.totalNonTechnical ?? sectionItems.reduce((total, item) => total + Number(item?.noOfNonTechnical || 0), 0);
                      const totalLabour = section?.totalLabour ?? sectionItems.reduce((total, item) => total + Number(item?.noOfLabour || 0), 0);

                      return <section className="dlr-view-section" key={section?._id || sectionIndex}>
                        <div className="dlr-view-section__header">
                          <span className="dlr-view-section__number">{sectionIndex + 1}</span>
                          <div>
                            <span>{langPreference?.work_item || "Work Item"}</span>
                            <strong>{section?.workItem || "-"}</strong>
                          </div>
                          <div>
                            <span>{langPreference?.location || "Location"}</span>
                            <strong>{section?.location || "-"}</strong>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-bordered mb-0 dlr-view-section__table">
                            <thead>
                              <tr>
                                <th className="text-nowrap" colSpan={3}>Sub-Contractor</th>
                                <th className="text-nowrap" colSpan={3}>Item</th>
                                <th className="text-nowrap">Tech</th>
                                <th className="text-nowrap">Non-Tech</th>
                                <th className="text-nowrap">Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {sectionItems.map((item, itemIndex) => <tr key={item?._id || itemIndex}>
                                <td colSpan={3}>{item?.vendorName}</td>
                                <td colSpan={3}>{item?.name}</td>
                                <td>{item?.noOfTechnical}</td>
                                <td>{item?.noOfNonTechnical}</td>
                                <td>{item?.noOfLabour}</td>
                              </tr>)}
                              <tr className="dlr-view-section__total">
                                <td colSpan={6}>{langPreference?.total_no_of_count || "Total No of count"}</td>
                                <td>{totalTechnical}</td>
                                <td>{totalNonTechnical}</td>
                                <td>{totalLabour}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {section?.remarks && <div className="dlr-view-section__remarks">
                          <span>{langPreference.remarks || "Remarks"}</span>
                          <p>{section.remarks}</p>
                        </div>}
                      </section>;
                    })}
                  </div>

                  <hr />

                  <ActivityHistory data={details} language={langPreference} />

                  <hr />
                  <div className="d-flex align-items-center justify-contend-start gap-2">
                  {!["approved","rejected"]?.includes(details?.status)   && userDetails?.roleId?.permission.includes("dlrApprove") && <div className="d-flex justify-content-between gap-2 mt-3">
                      <div className="btn btn-primary"  onClick={()=>navigate(`/dlr/update/${details?._id}`)}>{langPreference.edit || "Edit"}</div>
                    </div>}

                    {details?.status!== "created" && details?.status!== "approved" && details?.status!== "rejected" && userDetails?.roleId?.permission.includes("dlrApprove") && <div className="d-flex justify-content-between gap-2 mt-3">
                      <div className="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={()=>setUpdatedStatus("approved")}>{langPreference.approve || "Approve"}</div>
                    </div>}
                    {details?.status!== "created" && details?.status== "approved" && userDetails?.roleId?.permission.includes("dlrReject") && <div className="d-flex justify-content-between gap-2 mt-3">
                      <div className="btn btn-primary" data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={()=>setUpdatedStatus("rejected")}>{langPreference.reject || "Reject"}</div>
                    </div>}

                      {(details?.status?.toLowerCase() === "approved" || userDetails?.roleId?.permission?.includes("dlrDownload")) && <div className="d-flex justify-content-between gap-2 mt-3">
                      <button className="btn create-order text-white d-inline-flex align-items-center gap-2" disabled={download} onClick={getDownloadDpr}>
                        {download && <span className="spinner-border spinner-border-sm text-white" role="status" aria-hidden="true" />}
                        {download ? (langPreference?.downloading || "Downloading...") : (langPreference.download || "Download")}
                      </button>
                    </div>}


                  </div>
                  </div>
                  <div className="dlr-powered-brand px-5 py-2">
                    <img src="/Group.png" alt="MMS logo" />
                    <span>Powered by MMS</span>
                  </div>
                  {company?.letterheadFooter && <img src={companyAsset(company.letterheadFooter)} alt="Company letterhead footer" className="d-block w-100" style={{ height: "auto" }} />}
                </div>
                <aside className="dlr-comments-panel my-3" aria-label={langPreference?.comments || "Comments"}>
                  <div className="dlr-comments-header">
                    <div>
                      <h2>{langPreference?.comments || "Comments"}</h2>
                      <p>Comments apply to this entire DLR.</p>
                    </div>
                    <span className="dlr-comments-count" aria-label={`${comments.length} comments`}>{comments.length}</span>
                  </div>

                  <div className="dlr-comments-thread">
                    {comments.length ? comments.map((entry) => {
                      const firstName = entry.userId?.firstName || "User"
                      const lastName = entry.userId?.lastName || ""
                      const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
                      return <article className="dlr-comment" key={entry._id}>
                        <div className="dlr-comment-avatar" aria-hidden="true">{initials}</div>
                        <div className="dlr-comment-body">
                          <div className="dlr-comment-meta">
                            <span className="dlr-comment-author">{firstName} {lastName}</span>
                            <time dateTime={entry.createdAt}>{moment(entry.createdAt).format("DD MMM, HH:mm")}</time>
                          </div>
                          <p>{entry.comment}</p>
                        </div>
                      </article>
                    }) : <div className="dlr-comments-empty">
                      <i className="bi bi-chat-left-text" aria-hidden="true"></i>
                      <strong>{langPreference?.no_comments || "No comments yet"}</strong>
                      <span>Start a conversation about this DLR.</span>
                    </div>}
                  </div>

                  {canComment && <form className="dlr-comment-composer" onSubmit={submitComment}>
                    <label htmlFor="dlr-comment">{langPreference?.add_comment || "Add a comment"}</label>
                    <textarea
                      id="dlr-comment"
                      rows="3"
                      maxLength="2000"
                      placeholder="Add a comment about this DLR..."
                      value={comment}
                      onChange={(event) => setComment(event.target.value)}
                    />
                    <div className="dlr-comment-actions">
                      <span>{comment.length}/2000</span>
                      <button type="submit" disabled={savingComment || !comment.trim()}>
                        {savingComment && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
                        {savingComment ? (langPreference?.saving || "Saving...") : (langPreference?.comment || "Comment")}
                      </button>
                    </div>
                  </form>}
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal modalId={confirmModalId} handleConfirm={handleApproval} message={updatedStatus=="approved" ? langPreference?.approve_confirmation : langPreference?.confirm_reject ||  <>Are you sure you want to <br /> {updatedStatus} ?</>} />
      <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`} />
      <StatusModal
        modalId={statusModalId}
        message={confirmationMsg}
        handleClose={handleCloseStatusModal}
      />
    </>
  )
}

export default ViewDLR
